<template>
   <div class="vAlignTop">
        <drop ref="dropper" class="cont has-text-centered " :class="{handCursor: tgt}" @drop="drop" @dragover="dragOver" @dragleave="dragOut" @dragend="dragOut">
            <div v-show="!img2 && $parent.$parent.editMode && !bundleLoaded" class="has-text-centered"><span class="mas">+</span><br><span class="has-text-light">Drop Bundle Here</span></div>       
        </drop>
        <div v-show="!bundleLoaded" id="loaderDiv">&nbsp;</div>
        <bundle-public v-show="bundleLoaded" class=" borderRadius20" :info="tree[0]" v-bind:listIndex="0"></bundle-public>
   </div>
</template>

<script>

import M from 'minimatch'
import bundletn from '../BundleThumbnail.vue'
import bundlePublic from '../BundlePublic.vue'
import { AZEventBus } from '../AZEventBus'

export default {
    components: {bundletn, bundlePublic},
    props: {
        img: String, index: Number
    },
    data: function() {
        return {
            img2: '',
            tgt: '',
            type: null,
            loaded: false,
            handle: '',
            bundles: [],
            cards: [],
            tree: [],
            treeNoInbox: [],
            fulled: false,
            showContext: true,
            localProfile: {},
            item: {fState: false, fid: null, pubId: null},
            members: [],
            showGroup: false,
            myBundle: true,
            ratings: [],
            ratingsAvg: [],
            bundleLoaded: false,
            bund: {}
        }
    },

    mounted: function(){

        //if(this.$parent.$parent.source[this.$parent.index].params.cols[this.index]){
            this.type = this.$parent.$parent.source[this.$parent.index].params.type

            if(this.type == 'img'){
               /*  this.img2 = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].img
                this.tgt = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt
                this.loaded = true; */
          
            } else if(this.type == 'profile'){
             /*    this.img2 = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].img
                this.handle = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].handle
                this.tgt = `https://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}`
                this.loaded = true; */

            } else if(this.type == 'bundle'){
                this.bund = this.$parent.$parent.source[this.$parent.index].params.bund
                this.tgt = `https://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}/b/${this.bund.mCode}`
                if(this.bund.mCode)
                    this.makeTheCall()
                this.loaded = true;

            }
        //}
            

    },

    methods: {
        dragOver: function(){
            //console.log('asdfadfa')
            if(this.$parent.$parent.dataTransfer.type == 'bundle')
                this.$refs.dropper.$el.classList.add('imgDragOver')
        },
        dragOut: function(){
            this.$refs.dropper.$el.classList.remove('imgDragOver')
        },
        drop: function(){
            this.type = this.$parent.$parent.dataTransfer.type

           if(this.type == 'bundle'){
                this.$parent.$parent.source[this.$parent.index].params.bund.mCode = this.$parent.$parent.dataTransfer.bund.mCode
                this.bund = this.$parent.$parent.source[this.$parent.index].params.bund

                //Make a call to get bundle data
                this.makeTheCall()

                //this.bundContent = bund from api call


                this.$parent.$parent.source[this.$parent.index].params.bund.type = 'bundle'
                this.loaded = true;

                this.tgt = `https://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}/b/${this.bund.mCode}`
                this.$parent.$parent.source[this.$parent.index].params.bund.tgt = this.tgt
                AZEventBus.$emit('pageChanged', null)
            }

            this.$refs.dropper.$el.classList.remove('imgDragOver')
            this.$parent.$parent.dataTransfer = {}

        },

        navTo: function(){
            if(!this.$parent.$parent.editMode && this.tgt)
              window.location.href = this.tgt
        },

        changed: function(){
            if(this.tgt){
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt = this.tgt
                AZEventBus.$emit('pageChanged', null)
            }
        },

        makeTheCall: function(){
                let self = this
                function w(d){
                    az.addRemSpinner(false, 'id', 'loaderDiv') 
                    self.bundleLoaded = true;
                    self.loadUp(d)
                                
                }
                function n(){
                    az.addRemSpinner(false, 'id', 'loaderDiv')

                }


                az.addRemSpinner(true, 'id', 'loaderDiv')
                if(this.$root.app.isAuth)
                    this.$root.app.apiClient.get('subs/data/pubbundle/' + this.bund.mCode, {}, w, n)
                
                else
                    this.$root.app.apiClient.get('open/confirm/pubbundle/' + this.bund.mCode, {}, w, n)
        },

        loadUp: function(data){


            var self = this

            self.ratings = data.ratings || [];
            self.ratingsAvg = data.ratingsAvg || [];

            let localCards = data.cards
            this.localProfile =  data.profile

            this.members =  data.members.filter(e => {
            return e.handle != self.localProfile.handle
            })

            this.item.fState = data.profile.active
            this.item.fid = data.profile.fid
            this.item.pubId = data.profile.pubId

            for(var l = 0; l < data.bundles.length; l++){
            data.bundles[l].items = [];

            if(data.bundles[l].children){
                data.bundles[l].children = data.bundles[l].children.split(',')
            } else {
                data.bundles[l].children = []
            }

            data.bundles[l].branch = [data.bundles[l].id]

            /*   if(data.bundles[l].isRoot){
                data.bundles[l].itemsLoaded = true
            } */
            }

            this.bundles = data.bundles
            this.cards = data.cards

            if(self.bundles[0].id_cog != self.$root.app.userAttrs.sub)
            self.myBundle = false

                

            for(var i = 0; i < self.cards.length; i++){

                var ind;
                var parents = JSON.parse(self.cards[i].parents) || []
                self.cards[i].parents = JSON.parse(self.cards[i].parents)
                self.cards[i].tags = JSON.parse(self.cards[i].tags) || []

                if(self.$root.app.userAttrs.sub != self.cards[i].id_cog){
                    self.cards[i].myCard = false
                } else {
                    self.cards[i].myCard = true
                }
                
                for(var x = 0; x < parents.length; x++){

                    ind = self.bundles.findIndex(e => {
                        return e.id == parents[x].id
                    })

                    if(ind != -1){
                        self.bundles[ind].items.push({id: self.cards[i].id, p: parents[x].p, cardsIndex: i, entryId: parents[x].entryId, id_cog: self.cards[i].id_cog})
                    }
                    
                }

                //ratings

                let cd = self.cards[i];
                let myRatings = []
                for(var l=0; l < self.ratings.length; l++){
                    if(self.ratings[l].id_CARDS == cd.id){
                    myRatings.push({collabId: self.ratings[l].id_COLLAB, rating:  self.ratings[l].rating})
                    }
                }

                let avgRatings = []
                for(l=0; l < self.ratingsAvg.length; l++){
                    if(self.ratingsAvg[l].id_CARDS == cd.id){
                    avgRatings.push({collabId: self.ratingsAvg[l].id_COLLAB, rating:  self.ratingsAvg[l].rating})
                    }
                }

                cd.myRatings = myRatings;
                cd.avgRatings = avgRatings;

            }    

            for(var n=0; n < self.bundles.length; n++){

            if(self.bundles[n].items){
                self.bundles[n].items.sort(function(a,b){ return a.p - b.p})
            } 
            }

            self.bundles.forEach(e => {
            if(e.isAlias){
                let tgtB = self.bundles.find(b => {
                return b.id == e.aliasTgtId
                })
                e.children = tgtB.children;
                e.listName = tgtB.listName;
                e.items = tgtB.items;
                e.collabId = tgtB.collabId
                e.pubNote = tgtB.pubNote ? tgtB.pubNote : ''
                tgtB.hideIt = true
            }
            })

            self.tree = self.buildTree(self.bundles);

            self.tree.sort(function(a,b){ return a.p - b.p})

            self.treeNoInbox = self.tree


            if(self.deep){
            self.openBundle(self.deep, self.treeNoInbox)
            }

            self.loaded = true;
            /* if(reload){
            self.fullLoad = true
            }  */

            //states


            },
            buildTree: function(o){

            var self = this; 
            var hasDirtyBundles = false

            var allBids = []
            self.$root.app.bundles.forEach(x => {
              allBids.push(x.id)
            })

            function getChildren(ids, branch, collabId){
            var ret = []
            
            for(var i=0; i < ids.length; i++){

                  //if id is not in bundles array, continue
                    if(!allBids.includes(parseInt(ids[i]))){
                        continue
                    } 

                var newBranch = branch.concat([ids[i]])

                ret.push(o.find(function(e){
                    if(e.id == ids[i]){

                    e.branch = newBranch
                    e.processed = true
                    e.parentCollabId = collabId

                    if(e.dirt > 0){
                        hasDirtyBundles = true
                    }
                    
                    if(e.children.length > 0){
                        e.children = getChildren(e.children, newBranch, collabId)
                    }
                        return true
                    }
                    
                }))
                }
                return ret
            }

            var arr = []

            for(var i=0; i < o.length; i++){

            var e = o[i];

            if(e.hideIt){
                continue
            }

            if(e.hasOwnProperty('processed') || e.isRoot == false) continue

            hasDirtyBundles = false

            

            if(e.children.length > 0){
                e.children = getChildren(o[i].children, [o[i].id], e.collabId || null);
            } else {

            }


            e.branch = [e.id]
            e.processed = true

            if(hasDirtyBundles || e.dirt > 0){
                e.hasDirtyBundles = true
            } else {
                e.hasDirtyBundles = false
            }

            if(e.collabId){
                e.parentCollabId = e.collabId
            } else {
                e.parentCollabId = null
            }

            
            
            arr.push(e);


            }

            return arr
            },
    }
}
</script>

<style lang="sass" scoped>
    .mas
        font-size: 80px
        line-height: 80px
        color: #aaa
        position: relative
        top: calc(50% - 40px)

    .cont
        height: 100%
        overflow: hidden
        position: relative

    .tgtTA
        max-width: 100%
        position: absolute
        left: 5px
        top: 5px
        border-left: 6px solid #f1c232

    .avatar
        max-width: 150px
        border-radius: 30px
        border: 5px solid #aaa

    .tn
        border-left: 1px solid #f1c232
        //border-right: 1px solid #f1c232

    .prof
        border-left: 1px solid #ccc
        //border-right: 1px solid #ccc


       
        
</style>

